import {useRouter} from 'next/router';
import {useState} from 'react';
import {useAuth} from '../../../core/usecases/auth/AuthContext';
import {isStudentVerified} from '../../../core/usecases/auth/isStudentVerified';
import {canRequestUniversityEmailVerifyPrompt} from './canRequestUniversityEmailVerifyPrompt';
import {
  canShowUniversityEmailVerifyPrompt,
  suppressUniversityEmailVerifyPrompt,
} from './universityEmailVerifyPromptSuppression';

type Args = {
  // エントリー促進ポップアップと同時に開かないよう、呼び出し側から表示状態を受け取る
  isPostRegisterEntryPromptOpened: boolean;
  // 表示判定がAPI解決待ちの間に先行して開いてしまわないよう受け取る
  isPostRegisterEntryPromptDeciding: boolean;
};

export const useUniversityEmailVerifyPrompt = ({
  isPostRegisterEntryPromptOpened,
  isPostRegisterEntryPromptDeciding,
}: Args) => {
  const {status, user} = useAuth();
  const router = useRouter();
  const [isClosed, setIsClosed] = useState(false);

  const canRequest = canRequestUniversityEmailVerifyPrompt({
    isAuthenticated: status === 'authenticated',
    isStudentVerified: isStudentVerified(user),
    pathname: router.pathname,
    isPostRegisterEntryPromptOpened,
    isPostRegisterEntryPromptDeciding,
  });

  const opened =
    canRequest && !isClosed && canShowUniversityEmailVerifyPrompt();

  return {
    opened,
    close() {
      setIsClosed(true);
      suppressUniversityEmailVerifyPrompt();
    },
  };
};
